var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 230.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    fillRule: "nonzero",
    d: "M170.221 14.119h240.827c27.769 0 53.007 11.359 71.3 29.65C500.643 62.065 512 87.309 512 115.071c0 27.761-11.361 53.003-29.656 71.297-18.295 18.296-43.537 29.657-71.296 29.657H170.244c-31.517 17.192-70.464 19.31-104.926 2.749-29.199-14.032-52.344-40.233-61.375-73.929l-.024-.096C-4.264 114.11.741 83.027 15.455 57.542c14.72-25.495 39.167-45.377 69.846-53.599 29.724-7.964 59.866-3.512 84.92 10.176z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBF9E0",
    d: "M184.06 23.048h226.988c50.614 0 92.023 41.436 92.023 92.023v.002c0 50.587-41.436 92.023-92.023 92.023H184.141c12.08-9.057 22.55-20.642 30.546-34.493 14.729-25.511 19.731-56.629 11.514-87.3-6.935-25.879-22.196-47.332-42.141-62.255z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD433",
    d: "M88.288 15.12C143.491.328 200.232 33.088 215.025 88.29c14.79 55.202-17.969 111.944-73.171 126.735-55.203 14.792-111.944-17.968-126.735-73.17C.327 86.653 33.086 29.912 88.288 15.12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#141518",
    d: "M88.692 65.934c7.243 0 13.113 8.501 13.113 18.988s-5.87 18.989-13.113 18.989c-7.242 0-13.113-8.502-13.113-18.989s5.871-18.988 13.113-18.988zm-28.935 65.15c28.11 36.44 85.937 35.649 110.813-.07l4.055 4.031c-27.869 47.293-86.867 48.965-119.109.256l4.241-4.217zm81.693-65.15c7.243 0 13.113 8.501 13.113 18.988s-5.87 18.989-13.113 18.989c-7.243 0-13.113-8.502-13.113-18.989s5.87-18.988 13.113-18.988z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E2E2E",
    fillRule: "nonzero",
    d: "M281.129 86.074v45.331h17.5l-1.667 12.667h-32.331V86.074h16.498zm134.254 0l-1.667 11.416H398.8v11.583h13.167v11.167H398.8v12.249h15.916v11.583h-32.415V86.074h33.082zm-39.223 0l-12.333 25.832 13.583 32.166h-17.75l-12-30.916 12.583-27.082h15.917zm-28.917 0v57.998h-16.499V86.074h16.499zm-25.391 0v57.998h-16.498V86.074h16.498z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.da66671b719b3499b7cea5b3d7f3db5c.svg";
export { ForwardRef as ReactComponent };